/* eslint-disable */
import {
  Checkbox,
  Flex,
  Popover,
  Radio,
  Space,
  Modal,
  Form,
  Dropdown,
  message,
  Tabs,
} from "antd";
import React, { useEffect, useRef, useState, useMemo } from "react";
import {
  CaretDownOutlined,
  OneToOneOutlined,
  SyncOutlined,
  VerticalAlignBottomOutlined,
  MenuOutlined,
  BarsOutlined,
  ExclamationCircleOutlined,
  HistoryOutlined
} from "@ant-design/icons";
import api from "@/utils/api";
import http from "@/utils/http";
import { CustomTable } from "@/hocComponents";
import commonFn from "@/utils/commonFn";
import { createRangeFilter } from "@/utils/rangerFn";
import { Typography } from "antd";
import moment from "moment";
import DetailsModal from "./component/DetailsMadol";
import ChartMadol from "./component/ChartMadol"
import qs from "qs";
const { Text, Link } = Typography;
export default function ApprovalRequest() {
  const [form] = Form.useForm();
  // 默认选中的值
  const [selectedItems, setSelectedItems] = useState([]);
  const [options, setOptions] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [modelDetails, setModelDetails] = useState(false);
   const [modelChart, setModelChart] = useState(false);
  const [currentRecordId, setCurrentRecordId] = useState(null);
  const [activeTab, setActiveTab] = useState("readytopay");
  const [statusFilter, setStatusFilter] = useState(1);
  const [stateOptions, setStateOptions] = useState([]);
  const [selectedList, setSelectedList] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });
const [pickerDates, setPickerDates] = useState([]);
  const getPeriodList = async () => {
    try {
      const response = await http.get(api.getPeriodList);

      if (response.code === "1") {
        const formattedRole = response.data.map((item) => ({
          label: item,
          value: item,
        }));

        setStateOptions(formattedRole);
      }
    } catch (error) {
      message.error("Error fetching Company List");
      throw error;
    } finally {
    }
  };
  // 处理选项变化
  const handleChange = (checkedValues) => {
    setSelectedItems(checkedValues);
    // setColumns(
    //   initColumns.map((item) => ({
    //     ...item,
    //     hidden: !checkedValues.includes(item.dataIndex),
    //   }))
    // );
  };

  const handleTabChange = (key) => {
    setActiveTab(key);
    console.log("key", key);
    const newStatus = key === "readytopay" ? 1 : 2;
    setStatusFilter(newStatus);
    getTableListFn(1, pagination.pageSize, { ...tableHead, status: newStatus });
  };
  const sendFn = async () => {
    console.log("object", selectedRowKeys);
    if (!selectedRowKeys.length) {
      message.warning("Please select at least one item.");
      return;
    }
    Modal.confirm({
      title: "Send For Approval",
      icon: <ExclamationCircleOutlined />,
      content: `Are you sure you send for approval the selected data?`,
      okText: "Sure",
      cancelText: "Cancel",
      onOk: async () => {
        const params = {
          idList: selectedRowKeys,
        };

        try {
          const response = await http.get(api.getSendToVendorPayment, {
            params,
            paramsSerializer: (params) =>
              qs.stringify(params, { arrayFormat: "comma" }),
          });
          console.log(response);
          if (response.code === "1") {
            message.success("Send For Approval Successfully!");
            setSelectedRowKeys([]);
            getTableListFn(pagination.current, pagination.pageSize);
          } else {
            commonFn.modalFailedFn(response);
          }
        } catch (error) {
          console.error("Request failed:", error);
          message.error("Request failed");
        }
      },
      onCancel() {
        console.log("Cancel");
      },
      style: {
        top: "40%",
      },
    });
  };

  
  // 获取列表数据
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    try {
      const params = {
        page: current || pagination.current,
        count: pageSize || pagination.pageSize,
        status: statusFilter,
        ...tableHead,
      };
      const response = await http.get(api.getMonthlyWorkerPaymentShow, {
        params,
      });
      if (response && response.code == 1) {
        const list = (response.data.list || []).map((item, index) => ({
          ...item,
          "#": (params.page - 1) * params.count + index + 1,
        }));
        setTableList(list);
        setPagination((prev) => ({
          ...prev,
          total: response.data.total || 0,
          current: params.page,
          pageSize: params.count,
        }));
        setTableLoading(false);
      } else {
        message.error(response.msg);
      }
    } catch (error) {
      message.error(res.msg);
    } finally {
      setTableLoading(false);
    }
  };

  // Popover 的内容
  const content = (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <Checkbox.Group
        options={options}
        value={selectedItems}
        className="checkBox"
        onChange={handleChange}
      >
        <Space direction="vertical">
          {options.map((option) => (
            <Checkbox key={option.value} value={option.value}>
              {option.label}
            </Checkbox>
          ))}
        </Space>
      </Checkbox.Group>
    </div>
  );
  const content2 = <a>Export to CSV</a>;

  // table
  const initTableHead = {
    vendorName: null,
    role: null,
    module: null,
    firstName: null,
    dateTimeRequest: null,

  };
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({ event, key, type, setTableHead, getTableListFn });
  };

  const initColumns = [
    {
      title: "Action",
      key: "action",
      dataIndex: "propId",
      hidden: false,
      align: "center",
      width: 60,
      render: (text, record) => (
        commonFn.btnAuthorityFlag('ViewDetail') && (<Dropdown
          menu={{
            items: [
              {
                key: "Details",
                icon: <HistoryOutlined twoToneColor="#1677FF" />,
                label: <div>View Detail</div>,
              },
              // {
              //   key: "ChartDetails",
              //   icon: <BarsOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
              //   label: <div>View vendor clock chart</div>,
              // },
            ],
            onClick: (e) => handleMenuClick(e, record),
          }}
          trigger={["click"]}
        >
          <MenuOutlined className="col-blue" />
        </Dropdown>) || null
      ),
    },
    {
      title: "Vendor Name",
      dataIndex: "vendorName",
      titleType: "Input",
      width: 200,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "vendorName"),
    },
    {
      title: "Role",
      dataIndex: "role",
      titleType: "Input",
      width: 200,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "role"),
    },
    {
      title: "Pay Amount",
      dataIndex: "payAmount",
      titleType: "Input",
      width: 100,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "payAmount"),
          render: commonFn.amountToDollarFn,
    },
    {
      title: "Pay Period",
      dataIndex: "payPeriod",
      titleType: "Select",
      width: 100,
      isSorter: true,
      sortterMultiple: 3,
      selectOptions: stateOptions,
      onChange: (value) => tableFilterFn(value, "payPeriod", "Select"),
    },
    {
      title: "Job Count",
      dataIndex: "jobCount",
      titleType: "Input",
      width: 100,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "jobCount"),
    },
    {
      title: "Per Job Cost",
      dataIndex: "perJobCost",
      titleType: "Input",
      width: 100,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "perJobCost"),
         render: commonFn.amountToDollarFn,
    },
      {
    title: "Send Time",
    dataIndex: "sendTime",
    key: "sendTime",
    width: 150,
    align: "center",
    sorter: true,
    filterDropdown: createRangeFilter({
      startKey: "sSendTime",
      endKey: "eSendTime",
      setDates: setPickerDates,
      dates: pickerDates,
      setTableHead,
      getTableListFn,
      pagination,
    }),
   render: (text) => text ? moment(Number(text)).format("MM/DD/YYYY HH:mm") : ' '
  },
  ];

  const handleMenuClick = async (e, record) => {
    if (e.key === "Details") {
      setCurrentRecord(record);
      setCurrentRecordId(record.id);
      setModelDetails(true);
    }
    if(e.key === "ChartDetails"){
      console.log("打开chart");
       setCurrentRecord(record);
      setCurrentRecordId(record.id);
      setModelChart(true);
    }
  };
  const initDetailTableHead = {
    vendorName: null,
    requestNumber: null,
    payAmount: null,
    requestDate: null,
    requestStatus: null,
    jobType: null,
    supervisor: null,
    materialAmount: null,
    orderField:null,
    orderType:null,
    sSendTime:null,
    eSendTime:null,
  };
  const [detailTableHead, setDetailTableHead] = useState(initDetailTableHead);




  //复选框
  const rowSelection = {
    getCheckboxProps: (record) => ({
      style: record.isEmpty ? { display: "none" } : {},
      disabled: record.approve === "Waiting For Approval",
    }),
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(selectedRowKeys);
      setSelectedList(selectedRows);
      setSelectedRowKeys(selectedRowKeys);
    },
  };
  const handleTableChange = (newPagination, filters, sorter) => {
    console.log("跳转");
    // 需要传递当前的 tableHead 搜索条件 \搜索
    let orderField = "";
    let orderType = "";
    if (sorter && sorter.field) {
      orderField = sorter.field;
      orderType = sorter.order === "ascend" ? "asc" : "desc";
    }
    // getTableListFn(newPagination.current, newPagination.pageSize, tableHead);
    getTableListFn(newPagination.current, newPagination.pageSize, {
      ...tableHead,
      orderField,
      orderType,
    });
  };

  const initColunmsFn = () => {
    setTableHead(initTableHead);

    const transformedList = initColumns.map((item) => ({
      label: item.title,
      value: item.dataIndex,
    }));
    setOptions(transformedList);
    const transformedList2 = initColumns.map((item) => item.dataIndex);
    setSelectedItems(transformedList2);
  };

  const columns = useMemo(() => {
    return initColumns
      .map((col) => {
        if (col.dataIndex === "payPeriod") {
          return {
            ...col,
            selectOptions: stateOptions,
          };
        }
        return col;
      })
      .filter((col) => {
        if (col.dataIndex === "sendTime") {
          return activeTab === "payments";
        }
        return true;
      });
  }, [activeTab, stateOptions]);

  useEffect(() => {
    initColunmsFn();
    getTableListFn(1, 25);
    getPeriodList();
  }, [refreshKey]);

  return (
    <div>
      <Flex className="topDiv" justify="space-between" align="flex-start">
        <div>
          <Tabs
            activeKey={activeTab}
            onChange={handleTabChange}
            items={[
              { label: "Ready To Pay", key: "readytopay" },
              { label: "Payments", key: "payments" },
            ]}
          />
        </div>
        <div className="min-width">
          <Radio.Group defaultValue="a" size="middle">
            <Radio.Button value="a" onClick={() => setRefreshKey(+new Date())}>
              <SyncOutlined />
            </Radio.Button>
            <Radio.Button value="b">
              <Popover content={content} title="" trigger="click">
                <OneToOneOutlined />
                <CaretDownOutlined className="ft12" />
              </Popover>
            </Radio.Button>
            {commonFn.btnAuthorityFlag('Download') && <Radio.Button value="c">
              <Popover content={content2} title="" trigger="click">
                <VerticalAlignBottomOutlined />
                <CaretDownOutlined className="ft12" />
              </Popover>
            </Radio.Button> || null}
          </Radio.Group>
        </div>
      </Flex>
      {(commonFn.btnAuthorityFlag('SendForApproval') && activeTab === "readytopay" &&
        commonFn.btnDocFn({
          name: "Send For Approval",
          btnStyle: { marginBottom: 16 },
          noShowIcon: true,
          btnFn: sendFn,
        })) ||
        null}
      <CustomTable
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowSelection={{
          type: "checkbox",
          ...rowSelection,
        }}
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollY="310px"
        tableCss="maintenanceTable"
      />
      {/* Details */}

      <DetailsModal
        visible={modelDetails}
        onCancel={() => setModelDetails(false)}
        record={currentRecord}
        currentRecordId={currentRecordId}
        setCurrentRecordId={setCurrentRecordId}
      />
      <ChartMadol
      visible={modelChart}
        onCancel={() => setModelChart(false)}
        record={currentRecord}
        currentRecordId={currentRecordId}
        setCurrentRecordId={setCurrentRecordId}
      />
    </div>
  );
}
